import React, { useContext } from "react";

import AuthContext from "../contexts/AuthContext";

const useAuthContext = () => {
  const value = useContext(AuthContext);
  if (value === undefined) {
    throw new Error("useAuthContext can only be used inside AuthProvider");
  }
  return value;
};

export default useAuthContext;
